import styled from '@mui/material/styles/styled'
import Box from '@mui/material/Box'

export const ErrorMessageComponent = styled(Box, {
  name: 'ErrorMessageComponentBox',
  slot: 'Root',
  skipSx: true,
})(
  `
  font-family: 'Source Sans Pro',
    font-size: '12px',
    color: theme.palette.error.main,
    
`,
)
